import React, { useEffect, useState } from "react";
import ProgramForm from "../../form/ProgramForm";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function ProgramManager() {
  const [programs, setPrograms] = useState([]);
  const [editingProgramId, setEditingProgramId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchPrograms();
  }, []);

  const fetchPrograms = () => {
    axios.get("/api/v1/program/")
      .then(res => setPrograms(res.data))
      .catch(err => console.error(err));
  };

  const handleEdit = (id) => setEditingProgramId(id);
  const handleAddProgram = () => setEditingProgramId("new");

  const handleVIewTournament = (programId) => {
    navigate(`/rect/tournament/${programId}`);
  };

  const handleAddTournament = (programId) => {
    navigate(`/api/program/${programId}/tournaments`);
  };

  const handleCloseForm = () => {
    setEditingProgramId(null);
    fetchPrograms();
  };

  return (
    <div>
      <h2>Programs</h2>

      {!editingProgramId && (
        <button
          className="btn btn-success mb-3"
          onClick={handleAddProgram}
        >
          Add Program
        </button>
      )}

      {!editingProgramId ? (
        <ul className="list-group">
          {programs.map(prog => (
            <li
              key={prog.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <span>{prog.title}</span>

              <div>
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => handleEdit(prog.id)}
                >
                  Edit Program
                </button>
                 <button
                  className="btn btn-sm btn-success"
                  onClick={() => handleVIewTournament(prog.id)}
                >
                  View Tournament
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="mt-3">
          <button
            className="btn btn-secondary mb-2"
            onClick={handleCloseForm}
          >
            Back to list
          </button>

          <ProgramForm
            programId={
              editingProgramId === "new"
                ? null
                : editingProgramId
            }
          />
        </div>
      )}
    </div>
  );
}
